import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import authService from "shared-components/src/components/login/auth.service";
import { loginSuccess } from "shared-components/src/components/login/store/auth.actions";
import MainLayout from "../layout/main.layout";
import HomePage from "../pages/home.page";
import LoginPage from "../pages/login.page";
import RealtimePage from "../pages/realtime.page";
import SetupPage from "../pages/setup.page";
import WikiPage from "../pages/wiki.page";
import { routerPaths } from "./routerPaths";
import OverviewPage from "../pages/overview.page";
import SetupSensorsPage from "../pages/setupSenors.page";
import SetupWaterSystemsPage from "../pages/setupWaterSystems.page";
import SignupPage from "../pages/signup.page";
import UsersPage from "../pages/users.page";
import ActivationRequestPage from "../pages/activation_request.page";
import ForgotPasswordPage from "../pages/forgotPassword.page";
import ResetPasswordPage from "../pages/resetPassword.page";
import * as apiConfig from "./../config/api";
import { initializeApiService } from "shared-components/src/services/apiService";

const apiServiceConfig = {
  API_URL_LOGIN: apiConfig.API_URL_LOGIN,
  API_GET_ME: apiConfig.API_GET_ME + apiConfig.API_POPULATE_ALL,
  API_FORGOT_PASSWORD: apiConfig.API_FORGOT_PASSWORD,
  API_RESET_PASSWORD: apiConfig.API_RESET_PASSWORD,
  API_WEATHER_FORECAST: apiConfig.API_WEATHER_DATA,
  weatherApiKey: apiConfig.weatherApiKey,
  API_WEATHER_STATION_DATA: apiConfig.API_GET_DATASTREAMS_LIST,
  API_WEATHER_STATION_TIME_RANGE: apiConfig.API_SENSOR_MEASURE_DATA,
};

initializeApiService(apiServiceConfig);

const Router = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = authService.isAuthenticated(token);

  useEffect(() => {
    const isRemember = authService.isRemember();

    if (isRemember) {
      // Esegui la chiamata di verifica del token lato server
      // api.verifyToken(rememberMeToken)
      //   .then((response) => {
      //     if (response.data.valid) {
      dispatch(loginSuccess(isRemember));
      //   }
      // })
      // .catch((error) => {
      //   dispatch(loginFailure(error));
      // });
    }
  }, []);

  return (
    <Routes>
      <Route
        index
        element={
          isAuthenticated ? (
            <Navigate to={routerPaths.home} />
          ) : (
            <Navigate to={routerPaths.login} />
          )
        }
      />
      <Route path={routerPaths.login} element={<LoginPage />} />
      <Route path={routerPaths.signup} element={<SignupPage />} />
      <Route
        path={routerPaths.forgot_password}
        element={<ForgotPasswordPage />}
      />
      <Route
        path={routerPaths.reset_password}
        element={<ResetPasswordPage />}
      />
      <Route
        path={routerPaths.activation_request}
        element={<ActivationRequestPage />}
      />
      {isAuthenticated ? (
        <Route
          element={
            <MainLayout>
              <Outlet />
            </MainLayout>
          }
        >
          <Route path={routerPaths.home} element={<HomePage />} />
          <Route path={routerPaths.setup} element={<SetupPage />} />
          <Route
            path={routerPaths.setupSensors}
            element={<SetupSensorsPage />}
          />
          <Route
            path={routerPaths.setupWaterSystems}
            element={<SetupWaterSystemsPage />}
          />
          <Route path={routerPaths.overview} element={<OverviewPage />} />
          <Route path={routerPaths.realtime} element={<RealtimePage />} />
          <Route path={routerPaths.wiki} element={<WikiPage />} />
          <Route path={routerPaths.users} element={<UsersPage />} />
        </Route>
      ) : (
        <Route path="/*" element={<Navigate to={""} />} />
      )}
    </Routes>
  );
};

export default Router;
